import { render, staticRenderFns } from "./EditableBlock.vue?vue&type=template&id=282c2aac&"
import script from "./EditableBlock.vue?vue&type=script&lang=js&"
export * from "./EditableBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports